import { createApp } from 'vue'

import './init.js';
import App from './App.vue'
import router from './routes/index'
import api from './api/index'
import routerPlugin from './routes/plugin'
import store from './stores/index'
import toaster from "@meforma/vue-toaster"

import "@fortawesome/fontawesome-pro/scss/fontawesome.scss";
import "@fortawesome/fontawesome-pro/scss/regular.scss";
import "@fortawesome/fontawesome-pro/scss/solid.scss";
import "@fortawesome/fontawesome-pro/scss/light.scss";
import './assets/scss/tailwind.scss'

let app = createApp(App);

app.router = router;
app.config.globalProperties.$router = router;

app.api = api;
app.config.globalProperties.$api = api;

app.config.globalProperties.$store = store;

app
  .use(store)
  .use(router)
  .use(toaster)
  .use(routerPlugin)
  .mount('#app')
